// Generated by scripts/generate-public-surface.ts. Do not edit.

import type { CountryValidator } from "../../types";

import { createValidator } from "#stdnum-runtime";

const ruc: CountryValidator<"PE"> = createValidator(
  "pe.ruc",
  142,
);

export default ruc;
export const compact = ruc.compact;
export const format = ruc.format;
export const validate = ruc.validate;
export const generate = (): string =>
  ruc.generate?.() ??
  (() => {
    throw new Error(
      "Validator pe.ruc cannot generate values",
    );
  })();
